import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=0fb71d06&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=ts"
export * from "./LanguageToggle.vue?vue&type=script&lang=ts"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=0fb71d06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_89dbb194e6e12be1c54baf39fc67c9df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb71d06",
  null
  
)

export default component.exports